import { PassengerAppAreaRoutes } from '@backoffice-frontend/passenger-app-api'
import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { DeviceMobileIcon } from '@moia-dev/pace-icons'

export const PassengerAppAreaNavigationIcon = DeviceMobileIcon

export const PassengerAppAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={PassengerAppAreaRoutes.route}
      Icon={DeviceMobileIcon}
    />
  )
}
